import React from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col, Button } from 'antd';
import SiteLayout from '../../component/layout/Layout'
import fifaImg from '../../assets/img/banner_scroll.png'
import './user_home.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import HomeContent from '../../component/home_page_content/home_page_content'


const UserHome = () => {

    const settings = {
        infinite: true,
        autoplay: true,
        dots: true,
        autoplaySpeed: 6000,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
          ]
      };

    return(
        <SiteLayout>
            <div className="user_home_banner">
                <Row gutter={[16, 24]} className="user_home_banner_holder">
                    <Col xs = {{ span: 24 }} sm = {{ span: 24 }}  md = {{ span: 24 }}  lg = {{ span: 10 }} xl={{ span: 10 }} className="user_banner_text_container">
                        <div className="user_home_banner_text">
                            <h1 className="banner_h1">A New Home<br />
                            for African Gamers.</h1>
                            <h3 className="banner_h3">Play anywhere. Join anytime.</h3>
                            <div className="user_banner_button">
                                <NavLink exact to="/create-game">
                                    <Button type="primary" className="create">Create a Game</Button>
                                </NavLink>
                                <Button type="primary" className="deposit">Make a Deposit</Button>
                            </div>
                            <h4 className="banner_h4">Play your first Game on your first deposit absolutely free!</h4>
                        </div>
                    </Col>
                    <Col xs = {{ span: 24 }} sm = {{ span: 16, offset: 8 }}  md = {{ span: 16, offset: 8 }}  lg = {{ span: 14, offset: 0 }} xl={{ span: 14, offset: 0 }} className="slides_container">
                        <Slider {...settings}>
                            <div className="banner_sliders">
                                <div className="banner_slider_content">
                                    <img src={fifaImg} alt="" style={{ width: '100%', height: 'auto' }}/>
                                    <div className="banner_card_overlay">
                                        <h3>Sports. Racing</h3>
                                        <ul>
                                            <li>7 Games</li>
                                            <li>20 Playing</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="banner_sliders">
                                <div className="banner_slider_content">
                                    <img src={fifaImg} alt="" style={{ width: '100%', height: 'auto' }}/>
                                    <div className="banner_card_overlay">
                                        <h3>Action. Adventure</h3>
                                        <ul>
                                            <li>7 Games</li>
                                            <li>46 Playing</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="banner_sliders">
                                <div className="banner_slider_content">
                                    <img src={fifaImg} alt="" style={{ width: '100%', height: 'auto' }}/>
                                    <div className="banner_card_overlay">
                                        <h3>Fighting. Indie</h3>
                                        <ul>
                                            <li>7 Games</li>
                                            <li>16 Playing</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="banner_sliders">
                                <div className="banner_slider_content">
                                    <img src={fifaImg} alt="" style={{ width: '100%', height: 'auto' }}/>
                                    <div className="banner_card_overlay">
                                        <h3>Sports. Racing</h3>
                                        <ul>
                                            <li>7 Games</li>
                                            <li>20 Playing</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </Col>
                </Row>
            </div>
            <HomeContent />
        </SiteLayout>
    );
}

export default UserHome;